import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { PackLineRead } from '../../entities/pack-line.dto';

@Injectable()
export class PackLineStore extends AbstractEntityStore<PackLineRead> {
    constructor() {
        super(PFWmsEntities.PackLine);
    }
}
